import React, { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import TicketForm from "@/components/support/TicketForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/context/auth-context";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

const NewTicket = () => {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // If a ticket type is specified in the URL, it should be pre-selected
  const ticketType = searchParams.get("type");
  
  // If not authenticated, redirect to login
  useEffect(() => {
    if (profile === null) {
      navigate("/auth/login", { 
        replace: true,
        state: { from: "/support/tickets/new" }
      });
    }
  }, [profile, navigate]);

  if (profile === undefined) {
    return (
      <div className="container max-w-3xl mx-auto py-8">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-title text-primary">New Support Ticket</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="py-8 text-center">
              <p>Loading...</p>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (profile === null) {
    return (
      <div className="container max-w-3xl mx-auto py-8">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Authentication Required</AlertTitle>
          <AlertDescription>
            You need to be logged in to create a support ticket.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="w-full py-2 px-2">
      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="text-2xl font-title text-primary">New Support Ticket</CardTitle>
        </CardHeader>
        <CardContent>
          <TicketForm />
        </CardContent>
      </Card>
      
      <div className="mt-4 text-center">
        <Button 
          variant="ghost" 
          onClick={() => navigate("/support/tickets")}
        >
          Back to Tickets
        </Button>
      </div>
    </div>
  );
};

export default NewTicket;
